import React from 'react';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownPanelProps {
  showScarcity?: boolean;
}
export function CountdownPanel({
  showScarcity = true
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="mx-auto w-full max-w-narrow text-center" data-id="element-54" data-mp="l8ry9ed3afu0">
      <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-blue-700 md:text-base" data-id="element-55" data-mp="q6tezsn1m32b">
        <ClockIcon className="h-5 w-5 text-gold-600" aria-hidden="true" data-id="element-56" data-mp="c8bx4bjtjksb" />
        Precio de lanzamiento — cierra en:
      </p>

      <div className="mt-6 flex items-start justify-center gap-4 md:gap-8" role="timer" data-id="element-57" data-mp="26jgx95vp5f2w">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-58" data-mp="2bi207d2c2cv1">
            <span className="font-display text-5xl font-extrabold tabular-nums leading-none tracking-tight text-blue-600 md:text-7xl" data-id="element-59" data-mp="1lgyhg06dj0dy">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-900/55" data-id="element-60" data-mp="1v709f31ul2y5">
              {unit.label}
            </span>
          </div>)}
      </div>

      {showScarcity && <div className="mt-8" data-id="element-61" data-mp="12icf6hz4f38g">
          <p className="inline-flex items-center gap-2 rounded-xl bg-alert-50 px-4 py-2.5 text-sm font-semibold text-alert-600 ring-1 ring-alert-200 md:text-base" data-id="element-62" data-mp="12jdvb0uzufx1">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-63" data-mp="1cgigaxd3s5c9" />
            Después sube a $25.990 ARS. No vuelve.
          </p>

          <div className="mt-7" data-id="element-64" data-mp="17gdyn40gl4kg">
            <div className="flex items-baseline justify-between text-sm font-semibold text-blue-900/70" data-id="element-65" data-mp="17jidcvbjvipd">
              <span data-id="element-66" data-mp="2nxrylgkhwrbz">Cupos al precio de lanzamiento</span>
              <span data-id="element-67" data-mp="2ivj7kpr6nzci">Quedan 32</span>
            </div>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-blue-100" data-id="element-68" data-mp="2qxac5ueeqq2s">
              <div className="h-full w-[68%] rounded-full bg-gold-500" data-id="element-69" data-mp="2qzmqzyovckbm" />
            </div>
            <p className="mt-2 text-right text-xs text-blue-900/55" data-id="element-70" data-mp="2v0ylahiottq5">68% vendidos</p>
          </div>
        </div>}
    </div>;
}